<template>
  <div>
    <div class="row">
      <h4>篩選:</h4>
    </div>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-row>
          <el-col :span="8">
            <DatePciker ref="datepicker" @changeTime="changeTime"></DatePciker>
          </el-col>
          <el-col :span="8">
            <FilterOption
              :options="options"
              @selectFilter="selectFilter"
            ></FilterOption>
          </el-col>
          <el-col :span="8">
            <InputAutocomplete @handleSelect="handleSelect"></InputAutocomplete>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="downloadSigning">
          電子簽單下載
        </el-button>
        <el-button @click="showCreatedSigninModal">補單</el-button>
      </el-col>
    </el-row>
    <hr />
    <el-row>
      <el-col>
        <FilterTag ref="filterTag" @searchList="searchList"></FilterTag>
      </el-col>
    </el-row>
    <hr />
    <div class="row">
      <div class="row">
        <div class="col-md-3">
          <label>
            <select
              v-model="npp"
              @change="setPage(1)"
              name="datatable-checkbox_length"
              aria-controls="datatable-checkbox"
              class="form-control input-sm"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </label>
        </div>
        <div class="pull-right">
          <el-button type="primary" plain @click="updateIsAuth">
            確定更新企業查看權限
          </el-button>
        </div>
      </div>
      <el-row>
        <el-col class="table-col">
          <el-table :data="signing" style="width: 100%">
            <el-table-column fixed prop="id" label="單號">
              <template slot-scope="scope">
                <span class="index-click" @click="editSigning(scope.$index)">
                  {{ scope.row.id }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="companyName" label="公司名稱">
              <template slot-scope="scope">
                {{ scope.row.companyName }}
                <input
                  v-if="isShowInvoice"
                  :checked="scope.row.isInvoice"
                  type="checkbox"
                  class="flat"
                  @click="selectSigningOfInvoice(scope.$index)"
                  style="zoom: 180%"
                />
              </template>
            </el-table-column>

            <el-table-column prop="createdAt" label="訂單時間">
              <template slot-scope="scope">
                {{ getCreatedAt(scope.row.createdAt) }}
              </template>
            </el-table-column>

            <el-table-column label="司機編號-姓名">
              <template slot-scope="scope">
                {{ scope.row.callNumber }}-{{ scope.row.driverName }}
              </template>
            </el-table-column>

            <el-table-column prop="onAddress" label="上車地點" />
            <el-table-column prop="offAddress" label="下車地點" />
            <el-table-column prop="type" label="訂單種類" />
            <el-table-column prop="actualFare" label="司機填入金額" />
            <el-table-column prop="serviceFee" label="車隊服務金額" />
            <el-table-column prop="signingNote" label="簽單備註" />
            <el-table-column
              prop="employeeNameJobNumber"
              label="工號-員工姓名"
            />

            <el-table-column label="請款單/領款單">
              <template slot-scope="scope">
                <input
                  :checked="scope.row.invoiceId !== null"
                  type="checkbox"
                  class="flat"
                  disabled
                  style="zoom: 180%"
                />
                <input
                  :checked="scope.row.driverWithdrawal !== null"
                  type="checkbox"
                  class="flat"
                  disabled
                  style="zoom: 180%"
                />
              </template>
            </el-table-column>

            <el-table-column label="簽名檔" width="250">
              <template slot-scope="scope">
                <template v-for="item in scope.row.employeePhoto">
                  <el-row>
                    <el-col :span="6">
                      <el-button
                        size="mini"
                        type="danger"
                        v-show="getPhoto(item.photo)"
                        @click="removeSignature(item)"
                      >
                        X
                      </el-button>
                    </el-col>
                    <el-col :span="16">
                      <img
                        width="120"
                        height="100"
                        v-if="getPhoto(item.photo)"
                        :src="item.photo"
                      />
                      <span v-else style="color: red">網頁密碼認證</span>
                    </el-col>
                  </el-row>
                </template>
                <el-upload
                  class="upload-demo"
                  :data="scope.row"
                  drag
                  multiple
                  action=""
                  :http-request="uploadPhoto"
                  :auto-upload="true"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    將圖片(JPG)移到此處，或
                    <em>點擊上傳</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">檔案大小上限為1MB</div>
                </el-upload>
              </template>
            </el-table-column>

            <el-table-column label="允許企業查看">
              <template slot-scope="scope">
                <input
                  :checked="scope.row.isAuth"
                  type="checkbox"
                  class="flat"
                  @click="updateAllowInspect(scope.$index)"
                  style="zoom: 180%"
                />
              </template>
            </el-table-column>

            <el-table-column label="刪除簽單">
              <template slot-scope="scope">
                <el-button type="danger" @click="deleteSigning(scope.row.id)">
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div class="pull-right">
        <ul class="pagination">
          <li v-bind:class="{ disabled: page == 1 }">
            <a
              href="javascript:;"
              @click="clickNewPage(1)"
              v-bind:class="{ active: page == 1 }"
            >
              第一頁
            </a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="clickNewPage(pages_show_list[0] - 1)"
              v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1"
            >
              ...
            </a>
          </li>
          <li
            v-for="n in pages_show_list"
            v-bind:class="{ active: n == page }"
            @click="clickNewPage(n)"
          >
            <a href="javascript:;" ng-bind="n">{{ n }}</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="clickNewPage(pages_show_list[4] + 1)"
              v-show="
                page + 2 < totalPage && pages_show_list[4] + 1 < totalPage
              "
            >
              ...
            </a>
          </li>
          <li
            v-show="totalPage > 1"
            v-bind:class="{ disabled: page == totalPage }"
          >
            <a
              href="javascript:;"
              @click="clickNewPage(totalPage)"
              v-bind:class="{ active: page == totalPage }"
            >
              最後一頁
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      id="noteModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">選擇備註</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <select
              id="heard"
              class="form-control"
              v-model="modalNote"
              required=""
            >
              <option v-for="message in message_list" :value="message.item">
                {{ message.item }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="updateIsPayment"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModifyDataModal
      ref="modifyDataModal"
      @getSigningList="getSigningList()"
    ></ModifyDataModal>
    <CreateSigningModal
      ref="createSigningModal"
      @updateSigningList="getSigningList()"
      :companyList="companyList"
    ></CreateSigningModal>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'
import DownloadAPI from '../../assets/js/libs/DownloadAPI'
import ModifyDataModal from './ModifyDataModal'
import CreateSigningModal from './CreateSigningModal'
import DatePciker from '../element_ui/DatePicker'
import moment from 'moment'
import dayjs from 'dayjs'
import TimeRadioButton from '../element_ui/TimeRadioButton'
import InputAutocomplete from '../element_ui/InputAutocomplete'
import axios from 'axios'
import FilterOption from '../element_ui/filter_componet/Filter'
import FilterTag from '../element_ui/filter_componet/Tag'
import { cookies } from '@/utils/cookies'

export default {
  props: ['companyList'],
  components: {
    ModifyDataModal,
    CreateSigningModal,
    DatePciker,
    TimeRadioButton,
    InputAutocomplete,
    FilterOption,
    FilterTag,
  },
  data() {
    return {
      dialogVisible: false,
      startAt: '',
      endAt: '',
      signing: [],
      npp: 25,
      page: 1,
      count: 0,
      kw: '',
      driverList: [],
      driverId: 0,
      message_list: [
        { item: '不選擇', index: 0 },
        { item: '服務費', index: 1 },
        { item: '提前現領', index: 2 },
      ],
      filter_request_list: [
        { item: '未請錢', index: 1 },
        { item: '已請錢', index: 2 },
      ],
      filter_auth_list: [
        { item: '未授權', index: 1 },
        { item: '已授權', index: 2 },
      ],
      invoiceList: [],
      message: [0],
      totalPage: 1,
      // pages_show_list:[],
      isSelectAll: false,
      isSelectEnterpriseAuthAll: false,
      filterDriverAsk: '0',
      filterCompanyAuth: '是否授權企業',
      dateNum: 1,
      tickSigningAuth: [],
      nonTickSigningAuth: [],
      tickAskForMoney: [],
      nonTickAskForMoney: [],
      modalNote: '不選擇',
      invoiceId: 0,
      enterpriseId: 0,
      isShowInvoice: false,
      isSelectInvoiceAll: false,
      removeInvoiceList: [],
      signingInInvoice: [],
      enterpriseName: '選擇企業',
      filter: '',
      options: [],
      fileList: [],
    }
  },
  mounted() {
    this.options = [
      {
        value: 'day_num',
        label: '時間篩選',
        children: [
          {
            value: 1,
            label: '當天',
          },
          {
            value: 2,
            label: '昨天',
          },
          {
            value: 7,
            label: '最近一週',
          },
          {
            value: 31,
            label: '最近一月',
          },
          {
            value: 183,
            label: '最近半年',
          },
          {
            value: 366,
            label: '最近一年',
          },
        ],
      },
      {
        value: 'auth_inspect',
        label: '是否授權查看',
        children: [
          {
            value: 'false',
            label: '否',
          },
          {
            value: 'true',
            label: '是',
          },
        ],
      },
      {
        value: 'withdrawal',
        label: '是否放入領款單',
        children: [
          {
            value: 'false',
            label: '否',
          },
          {
            value: 'true',
            label: '是',
          },
        ],
      },
      {
        value: 'invoice',
        label: '是否放入請款單',
        children: [
          {
            value: 'false',
            label: '否',
          },
          {
            value: 'true',
            label: '是',
          },
        ],
      },
    ]
    this.getSigningList(this.page)
    this.getInvoiveList()
  },
  methods: {
    handleClose() {},
    async uploadPhoto(file) {
      // console.log("======", file.data.id);
      // console.log("======", file.file);
      const form = new FormData()
      form.append('photo', file.file)
      form.append('signId', file.data.id)

      const res = await EnterpriseAPI.post('enterprise/signing/photo', form, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      })
      if (res.result === true) {
        this.getSigningList(this.page)
      }
    },
    removeSignature(item) {
      if (confirm('確定要刪除員工簽名嗎？ 刪除後無法復原'))
        EnterpriseAPI.delete(`enterprise/signature/${item.signatureId}`)
          .then((res) => {
            if (!res.success) throw new RangeError(res.result)
            this.$msg('刪除成功')
            this.getSigningList()
          })
          .catch((err) => {
            this.$msg(err.message)
          })
    },
    getCreatedAt(d) {
      if (d) {
        const date = dayjs(d).format('YYYY-MM-DD HH:mm:ss')
        const dayArr = ['日', '一', '二', '三', '四', '五', '六']
        const dayIdx = dayjs(date).day()
        return `${date}(${dayArr[dayIdx]})`
      }
      return ''
    },
    searchList(val) {
      // console.log("emit search list");
      console.log(this.options)
      this.filter = ''
      for (let i = 0; i < val.length; i++) {
        if (typeof val[i].value === 'object') {
          let startTime = moment(val[i].value.startTime)
            .tz('Europe/London')
            .format('YYYY-MM-DD 16:00:00')
          let endTime = moment(val[i].value.endTime)
            .tz('Europe/London')
            .format('YYYY-MM-DD 15:59:59')
          this.filter =
            this.filter + `&day_num=0&startAt=${startTime}&endAt=${endTime}`
          this.$refs.datepicker.clearData()
        } else {
          this.filter = this.filter + `&${val[i].key}=${val[i].value}`
        }
      }
      // console.log(this.filter);
      this.getSigningList(1)
    },
    selectFilter(val) {
      // console.log("vale", val);
      if (val.key === 'enterprise_id') {
        this.enterpriseId = val.value
      }
      this.$refs.filterTag.setTag(val)
    },
    getPhoto(item) {
      if (item === '輸入密碼產生') return false
      return item
    },
    deleteSigning(id) {
      if (confirm('確定要刪除企業簽單嗎？ 刪除後無法復原'))
        EnterpriseAPI.delete(`enterprise/signing/${id}`)
          .then((res) => {
            if (res.success) {
              this.getSigningList(this.page)
            } else {
              this.$msg(res.result)
            }
          })
          .catch((err) => {
            this.$msg(err.message)
          })
    },
    employeeJobNumberName(array) {
      // console.log(array);
      let employeeJobName = ''
      for (let i = 0; i < array.length; i++) {
        employeeJobName =
          employeeJobName +
          `${array[i].employeeJobNumber}-${array[i].employeeName}` +
          ','
      }
      return employeeJobName
    },
    downloadSigning() {
      if (this.startAt === '' || this.endAt === '') return alert('請選擇時間')
      alert(
        '即將開啟新視窗，請到「大量作業」下載。\n(若瀏覽器有阻擋開啟分頁，請自行開啟大量作業頁面)',
      )
      let object = {
        start: moment(this.startAt)
          .tz('Europe/London')
          .format('YYYY-MM-DD 16:00:00'),
        end: moment(this.endAt)
          .tz('Europe/London')
          .format('YYYY-MM-DD 15:59:59'),
      }
      // console.log(object.start, object.end);
      axios
        .post(
          `${DownloadAPI.getAPIUrl}excel/enterprise_signing-excel?start=${object.start}&end=${object.end}`,
          {
            params: object,
            headers: {
              'x-access-token': cookies.get('user'),
            },
          },
        )
        .then(() => {
          const downloadLink = this.$router.resolve({ name: 'WorkingStatus' })
          window.open(downloadLink.href, '_blank')
        })
        .catch(function (error) {
          alert('不得超過一個月或時間錯誤')
          console.error(error)
        })
    },
    changeTime(val) {
      this.startAt = val[0]
      this.endAt = val[1]
      this.dateNum = 0
      let object = {
        key: 'day_num',
        title: `篩選時間: ${this.startAt}~${this.endAt}`,
        value: {
          startTime: this.startAt,
          endTime: this.endAt,
        },
      }
      this.selectFilter(object)
      // this.getSigningList(1)
    },
    // selectDriver(){
    //   EnterpriseAPI.get(`enterprise/signingList?kw=${this.kw}&driverAsk=${this.filterDriverAsk}&auth=${this.filterCompanyAuth}&day_num=30&enterpriseId=${this.enterpriseId}&driverId=${this.driverId}`
    //   ).then((res) => {
    //     console.log(res)
    //     if(res.success){
    //       let {count, list} = res.result;
    //       this.count = count;
    //       this.signing = list;
    //       return
    //     }
    //     this.count = 0;
    //     this.signing = [];
    //   }).catch((err) => {
    //     this.$msg(err.message);
    //   });
    // },
    initial() {
      ;(this.isSelectAll = false), (this.isSelectEnterpriseAuthAll = false)
    },
    getYearOptions() {
      this.years.push(moment().year())
      if (moment().month() - 5 < 0) {
        this.years.push(moment().year() - 1)
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      if (this.year == moment().year()) {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month <= moment().month() + 1) {
            this.months.push(month)
          }
        }
      } else {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month > moment().month() + 1) {
            this.months.push(month)
          }
        }
      }
    },
    filterDate(date) {
      this.$refs.datepicker.clearData()
      this.dateNum = date
      this.getSigningList(1)
    },
    handleSelect(val) {
      // console.log(val);
      this.driverId = val.id
      let object = {
        key: 'driver_id',
        title: val.value,
        value: this.driverId,
      }
      this.$refs.filterTag.setTag(object)
      // this.getSigningList(1)
    },
    getSigningList(page) {
      if (page === null || page === undefined || page === '') page = this.page
      let url = `enterprise/signingList/v2?page=${page}&npp=${this.npp}${this.filter}`
      // console.log(url)
      EnterpriseAPI.get(url)
        .then((res) => {
          // console.log("資料", res);
          if (res.success) {
            let { count, list } = res.result
            this.count = count
            this.signing = list
            this.totalPage = Math.ceil(this.count / this.npp)
          } else {
            // 此情況statusCode=200，但在使用者的搜尋條件下並無資料
            this.$msg(res.result)
          }
        })
        .catch((err) => {
          console.error(err)
          this.count = 0
          this.signing = []
          this.totalPage = 0
          // this.$msg(err.message);
        })
    },
    updateAllowInspect(index) {
      // 點選checkbox，打勾=> 放入tickSigningAuth, 不打勾=> 放入nonTickSigningAuth, array互相不重複
      this.signing[index].isAuth = !this.signing[index].isAuth
      this.operateArray(
        this.signing[index].authTime,
        this.signing[index].isAuth,
        this.nonTickSigningAuth,
        this.tickSigningAuth,
        this.signing[index].id,
      )
    },
    updateDriverAsk(index) {
      this.signing[index].isPayment = !this.signing[index].isPayment
      this.operateArray(
        this.signing[index].payTime,
        this.signing[index].isPayment,
        this.nonTickAskForMoney,
        this.tickAskForMoney,
        this.signing[index].id,
      )
      if (!this.signing[index].isPayment) {
        this.message = 0
      }
    },
    selectNote(message, index) {
      let item = this.message_list[message.target.value].item
      this.signing[index].isPayment = message.target.value === 0 ? false : true
      if (
        this.signing[index].isPayment &&
        this.signing[index].payTime === null
      ) {
        this.requestSingleAskForMoneyAPI(index, item, 'payment')
      }
      if (
        !this.signing[index].isPayment &&
        this.signing[index].payTime !== null
      ) {
        this.requestSingleAskForMoneyAPI(index, item, 'nonpayment')
      }
    },
    clickNewPage(page) {
      this.page = page
      this.getSigningList(page)
    },
    requestSingleAskForMoneyAPI(index, message, tag) {
      let payload = {}
      if (tag === 'payment') {
        payload = {
          tickId: this.signing[index].id, // format: 1,2,3,4,5
          nonTickId: '',
          tickNote: message,
        }
      } else {
        payload = {
          tickId: '', // format: 1,2,3,4,5
          nonTickId: this.signing[index].id,
        }
      }
      EnterpriseAPI.put('enterprise/askformoney', payload)
        .then((res) => {
          if (res.success) {
            this.$msg('修改成功')
            this.getSigningList(this.page)
            return
          }
          his.$msg('修改失敗，請再試一次:' + res.result)
        })
        .catch((err) => {
          this.$msg('修改失敗，請再試一次')
        })
    },
    showNoteModal() {
      this.tickAskForMoney.length === 0
        ? this.updateIsPayment()
        : $('#noteModal').modal('show')
    },
    hideNoteModal() {
      $('#noteModal').modal('hide')
    },
    updateIsPayment() {
      let payload = {
        tickId: this.tickAskForMoney, // format: 1,2,3,4,5
        nonTickId: this.nonTickAskForMoney,
        tickNote: this.modalNote,
      }
      EnterpriseAPI.put('enterprise/askformoney', payload)
        .then((res) => {
          if (res.success) {
            this.$msg('修改成功')
            this.getSigningList(this.page)
            this.hideNoteModal()
            return
          }
          this.$msg('修改失敗，請再試一次:' + res.result)
        })
        .catch((e) => {
          console.error(e)
          this.$msg('修改失敗，請再試一次')
        })
    },
    updateIsAuth() {
      let payload = {
        tickId: this.tickSigningAuth, // format: 1,2,3,4,5
        nonTickId: this.nonTickSigningAuth,
      }
      EnterpriseAPI.put('enterprise/signingauth', payload)
        .then((res) => {
          if (res.success) {
            this.$msg('修改成功')
            this.getSigningList(this.page)
            return
          }
          this.$msg('修改失敗，請再試一次:' + res.result)
        })
        .catch((e) => {
          console.error(e)
          this.$msg('修改失敗，請再試一次')
        })
    },
    selectAllEnterpriseAuth() {
      this.isSelectEnterpriseAuthAll = !this.isSelectEnterpriseAuthAll
      for (let i = 0; i < this.signing.length; i++) {
        this.signing[i].isAuth = this.isSelectEnterpriseAuthAll
        this.operateArray(
          this.signing[i].authTime,
          this.isSelectEnterpriseAuthAll,
          this.nonTickSigningAuth,
          this.tickSigningAuth,
          this.signing[i].id,
        )
      }
    },
    selectAllItem() {
      this.isSelectAll = !this.isSelectAll
      for (let i = 0; i < this.signing.length; i++) {
        this.signing[i].isPayment = this.isSelectAll
        this.operateArray(
          this.signing[i].payTime,
          this.isSelectAll,
          this.nonTickAskForMoney,
          this.tickAskForMoney,
          this.signing[i].id,
        )
      }
    },
    addElementToArray(array, id) {
      if (array.indexOf(id) === -1) {
        array.push(id)
      }
    },
    removeArrayElement(array, id) {
      if (array.indexOf(id) !== -1) {
        array.splice(array.indexOf(id), 1)
      }
    },
    selectDriverFilter(filterDriverAsk) {
      this.filterDriverAsk = filterDriverAsk
      this.initial()
      this.getSigningList(1)
    },
    /* selectAuth(val) {
      this.initial()
      this.getSigningList(1)
    }, */
    operateArray(time, isSelect, nonTickArray, tickArray, id) {
      // console.log("======", time);
      // console.log("======", isSelect);

      if (time !== null) {
        if (isSelect) {
          // 移除array, nonArray
          this.removeArrayElement(tickArray, id)
          this.removeArrayElement(nonTickArray, id)
        } else {
          // 移除array, 加nonArray
          this.removeArrayElement(tickArray, id)
          this.addElementToArray(nonTickArray, id)
        }
        return
      }
      if (isSelect) {
        // 加array, 移nonArray
        this.removeArrayElement(nonTickArray, id)
        this.addElementToArray(tickArray, id)
      } else {
        // 移除array, nonArray
        this.removeArrayElement(nonTickArray, id)
        this.removeArrayElement(tickArray, id)
      }
    },
    editSigning(index) {
      // if(this.signing[index].driverWithdrawal === null && this.signing[index].invoiceId === null){
      let info = {
        onAddress: this.signing[index].onAddress,
        offAddress: this.signing[index].offAddress,
        signingNote: this.signing[index].signingNote,
        enterpriseSignId: this.signing[index].id,
        price: this.signing[index].actualFare,
        serviceFee: this.signing[index].serviceFee,
        serviceNote: this.signing[index].serviceNote,
        invoiceId: this.signing[index].invoiceId,
        driverWithdrawal: this.signing[index].driverWithdrawal,
      }
      this.$refs.modifyDataModal.setValues(info)
      return
      // }
      // alert('此簽單已經產生司機領款單或是企業請款單')
    },
    showCreatedSigninModal() {
      this.$refs.createSigningModal.showModal()
    },
    selectInvoice() {
      this.isShowInvoice = parseInt(this.invoiceId) !== 0
      this.getSigningList(1)
    },
    selectAllInvoice() {
      // 使用者全選簽單
      this.isSelectInvoiceAll = !this.isSelectInvoiceAll
      for (let i = 0; i < this.signing.length; i++) {
        this.signing[i].isInvoice = this.isSelectInvoiceAll
        this.operateArray(
          this.signing[i].invoiceId,
          this.isSelectInvoiceAll,
          this.removeInvoiceList,
          this.signingInInvoice,
          this.signing[i].id,
        )
      }
    },
    selectSigningOfInvoice(index) {
      // 使用者選擇單一簽單
      this.signing[index].isInvoice = !this.signing[index].isInvoice
      this.operateArray(
        this.signing[index].invoiceId,
        this.signing[index].isInvoice,
        this.removeInvoiceList,
        this.signingInInvoice,
        this.signing[index].id,
      )
    },
    getInvoiveList() {
      EnterpriseAPI.get(`enterprise/invoice`)
        .then((res) => {
          const { list } = res.result
          this.invoiceList = list
        })
        .catch((err) => {
          this.$msg(err.message)
        })
    },
    getInvoiceSigningList() {
      EnterpriseAPI.get(
        `enterprise/signingList?
              kw=${this.kw}&
              driverAsk=${this.filterDriverAsk}&
              auth=${this.filterCompanyAuth}&
              day_num=${this.dateNum}&
              invoiceId=${this.invoiceId}`,
      )
        .then((res) => {
          if (res.success) {
            let { count, list } = res.result
            this.count = count
            this.signing = list
            // console.log(this.signing);
            return
          }
          this.count = 0
          this.signing = []
        })
        .catch((err) => {
          this.$msg(err.message)
        })
    },
    takeSigningToInvoice() {
      if (this.invoiceId === 0) {
        return alert('未選擇請款單')
      }
      let payload = {
        invoiceId: this.invoiceId,
        tickId: this.signingInInvoice.join(','),
        nonTickId: this.removeInvoiceList.join(','),
      }
      EnterpriseAPI.put('enterprise/invoice/signing', payload)
        .then((res) => {
          if (res.success) {
            this.$msg('修改成功')
            this.getSigningList(1)
            return
          }
          this.$msg('修改失敗，請再試一次:' + res.result)
        })
        .catch((e) => {
          console.error(e)
          this.$msg('修改失敗，請再試一次')
        })
    },
    setPage() {
      // console.log(this.npp);
      this.getSigningList(1)
      // this.totalPage = Math.ceil(count/this.npp)
    },
  },
  computed: {
    pages_show_list() {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
}
</script>
<style scoped>
.index-click {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}

.el-upload__input {
  visibility: hidden !important;
}

.el-table {
  height: auto !important;
}

.el-table >>> th {
  background-color: #2a3f54 !important;
  color: #fff;
}
.upload-demo >>> .el-upload-dragger {
  width: 25vh;
}
</style>



// WEBPACK FOOTER //
// src/components/company/SigningList.vue